import { Event } from "../Event";
export class PersonRfvEvents extends Event {
    //init onAdd
    public onAdd = (AddedValues: any) => {
        // alert("ADDED!");
        this.setValue('person_rfv_grade','oi');
    }
    //end
}
